import React from 'react';
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";

const ShowEmptyListMessage = ({dataList, dataFetchInProgress = false, label}) => {
    return (
        <>
            {dataList?.length === 0 &&
                <div className="w-full h-96 flex rounded-md items-center justify-center bg-white">
                    <div className="mr-2">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>

                    <div className="text-xl text-gray-600">
                        {!dataFetchInProgress &&
                            <div>No {label} Available</div>
                        }
                        {dataFetchInProgress &&
                            <div>Fetching {label}... </div>
                        }
                    </div>
                </div>
            }
        </>
    )
}

export default ShowEmptyListMessage
